module.exports = __webpack_public_path__ + "static/media/文法知识产权_x264.f50481c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/文法知识产权_x264.mp4
// module id = JX7H
// module chunks = 13